module.exports = __webpack_public_path__ + "static/media/facebook.3b6d3b95.png";